module.exports = __webpack_public_path__ + "static/media/play_section.63e5555c.svg";